import { gsap } from "gsap";

const duration = 0.3 // in seconds

export default {
	name: 'fade',
	sync: false,

	beforeLeave(){
		docToggle('aos-loading', true)
	},

	leave(){
		return new Promise( resolve => setTimeout(resolve, 400) )
	},

	afterLeave( data ){
		if( !['back','forward'].includes(data.trigger) ){
			window.scroll(0,0)
		}
	},
}
